<template>
  <div class="shop">
    <div>
      <el-button size="mini" type="primary" @click="addOperateAd"
        >添加</el-button
      >
      <span style="margin-left: 10px; color: #666"
        >提示：同一广告位在同时段仅支持展示一个广告，如有多个广告设置，则默认展示最新一条</span
      >
    </div>

    <el-table
      :data="tableData"
      max-height="720"
      style="width: 100%; margin-top: 20px"
      :cell-style="tc"
      :header-cell-style="tccolor"
    >
      <el-table-column label="ID" prop="id"></el-table-column>
      <el-table-column label="广告位">
        <template slot-scope="scope">
          <p v-if="scope.row.board_id == 1">首页轮播广告</p>
          <p v-if="scope.row.board_id == 2">首页文字广告</p>
          <p v-if="scope.row.board_id == 3">首页弹窗广告</p>
          <p v-if="scope.row.board_id == 4">进货轮播广告</p>
        </template>
      </el-table-column>
      <el-table-column label="广告类型">
        <template slot-scope="scope">
          <p v-if="scope.row.show_type == 1">文字</p>
          <p v-if="scope.row.show_type == 2">图片</p>
        </template>
      </el-table-column>
      <el-table-column label="图片展示">
        <template slot-scope="scope">
          <el-image
            v-if="scope.row.show_content"
            style="width: 100px; height: 100px"
            :src="scope.row.show_content"
            fit="contain"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column label="展示时间">
        <template slot-scope="scope">
          {{ formatTime(scope.row.ad_start_time, 'Y/M/D h:m:s') }}-{{
            formatTime(scope.row.ad_end_time, 'Y/M/D h:m:s')
          }}
        </template>
      </el-table-column>
      <el-table-column label="当前状态">
        <template slot-scope="scope">
          {{ editBeginOrEnd(scope.row.ad_start_time, scope.row.ad_end_time) }}
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" @click="editAd(scope.row)">编辑</el-button>
          <el-button size="mini" type="primary" @click="deleteAd(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <jdialog
      :title="isEditAd ? '编辑广告(弹窗广告)' : '添加广告(弹窗广告)'"
      :visible.sync="showAddEditAD"
      width="600px"
    >
      <el-form
        :model="pushform"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item label="添加广告位:">
          <el-select
            v-model="pushform.board_id"
            size="mini"
            placeholder="请选择类型"
          >
            <el-option label="首页弹窗广告位" value="3"></el-option>
            <el-option label="首页文字轮播广告位" value="2"></el-option>
            <el-option label="首页banner轮播广告位" value="1"></el-option>
            <el-option label="进货banner轮播广告位" value="4"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="选择弹窗类型:" v-if="pushform.board_id != 2">
          <el-radio v-model="pushform.show_type" label="2">纯图片</el-radio>
          <el-radio v-model="pushform.show_type" label="1">纯文字</el-radio>
        </el-form-item>

        <el-form-item label="显示终端:">
          <el-select
            v-model="pushform.equipment"
            size="mini"
            placeholder="请选择类型"
          >
            <el-option label="全部显示" value="0"></el-option>
            <el-option label="安卓展示" value="1"></el-option>
            <el-option label="ios展示" value="2"></el-option>
            <el-option label="小程序展示" value="3"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="内容标题:">
          <el-input
            maxlength="32"
            v-model="pushform.title"
            placeholder="请输入标题内容"
            size="mini"
            style="width: 320px"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="文案内容:" v-if="pushform.show_type == 1">
          <el-input
            maxlength="64"
            v-model="pushform.show_content"
            placeholder="请输入文案内容"
            size="mini"
            style="width: 320px"
            show-word-limit
          ></el-input>
        </el-form-item>

        <el-form-item label="图片上传:" v-if="pushform.show_type == 2">
          <uploadImg
            flieName="show_content"
            class="icon_cate"
            :oldImgs="[pushform.show_content]"
            :n="1"
            @getFile="getFile"
          ></uploadImg>
          <span class="note_pic">支持png、jpg格式照片，大小不能超过1M</span>
        </el-form-item>

        <el-form-item label="跳转方式:">
          <el-select
            v-model="pushform.url_param"
            size="mini"
            placeholder="请选择跳转类型"
            style="width: 140px; margin-right: 10px"
          >
            <el-option value="1" label="商品分类"></el-option>
            <el-option value="2" label="商品详情页"></el-option>
            <el-option value="3" label="跳转链接"></el-option>
            <el-option value="4" label="不跳转"></el-option>
          </el-select>

          <el-select
            v-model="cate_id"
            size="mini"
            placeholder="请选择商品分类"
            v-if="pushform.url_param == 1"
          >
            <el-option
              v-for="(item, index) in cateList"
              :key="'s' + index"
              :value="item.id"
              :label="item.cate_name"
            >
            </el-option>
          </el-select>
          <el-input
            size="mini"
            placeholder="请输入商品id"
            style="width: 240px"
            v-model="shop_id"
            v-if="pushform.url_param == 2"
          ></el-input>
          <el-input
            size="mini"
            placeholder="请输入链接"
            style="width: 300px"
            v-model="link"
            v-if="pushform.url_param == 3"
          >
          </el-input>
        </el-form-item>

        <el-form-item label="最高展示次数:" v-if="pushform.board_id != 1">
          <el-select v-model="pushform.max_show_number">
            <el-option value="1" label="1次"></el-option>
            <el-option value="2" label="2次"></el-option>
            <el-option value="3" label="3次"></el-option>
            <el-option value="0" label="不限制次数"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="排序" v-if="pushform.board_id == 1">
          <el-input
            size="mini"
            v-model="pushform.sort"
            style="width: 160px"
            placeholder="请输入排序"
          ></el-input>
        </el-form-item>

        <el-form-item label="展示时间段:">
          <el-date-picker
            v-model="pushform.ad_start_time"
            type="datetime"
            style="width: 192px"
            value-format="yyyy-MM-dd HH:mm:ss"
            size="small"
            placeholder="选择开始时间"
          ></el-date-picker>
          <span class="guodu">~</span>
          <el-date-picker
            v-model="pushform.ad_end_time"
            type="datetime"
            style="width: 192px"
            size="small"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择结束时间"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>

      <div style="text-align: center">
        <el-button size="mini" @click="cancenAddAd">取消</el-button>
        <el-button size="mini" @click="certainAddAd">确定</el-button>
      </div>
    </jdialog>
  </div>
</template>

<script>
import uploadImg from '@/components/uploadImg'
import { supplyproductCateListNew } from '@/api/autarky'
import {
  createBanner,
  getNewBannerList,
  updateBanner,
  deleteBanner,
} from '@/api/setting'
export default {
  components: {
    uploadImg,
  },
  data() {
    return {
      tableData: [],
      showAddEditAD: false,
      shop_id: '',
      cate_id: '',
      link: '',
      currentAdId: '',
      pushform: {
        //1 首页轮播 2 首页文字 3 首页弹窗
        board_id: '',
        //1 文字 2 图片
        show_type: '',
        //标题
        title: '',
        show_content: '',
        //跳转链接
        url_param: '',
        //最高展示次数
        max_show_number: '',
        ad_start_time: '',
        ad_end_time: '',
        //排序
        sort: '',
        equipment: '',
      },
      cateList: [],
      isEditAd: false,
      allowMultiClick: false,
    }
  },
  mounted() {
    this.getsupplyproductCateListData()
    getNewBannerList().then((res) => {
      this.tableData = res.data
    })
  },
  methods: {
    //添加广告
    addOperateAd() {
      this.isEditAd = false
      this.showAddEditAD = true
      this.pushform = {
        board_id: '',
        title: '',
        show_type: '',
        show_content: '',
        sort: '',
        max_show_number: '',
        url_param: '',
        ad_start_time: '',
        ad_end_time: '',
        url_type: 0,
        equipment: '',
      }
    },
    //编辑
    editAd(form) {
      this.isEditAd = true
      this.showAddEditAD = true
      // this.textData.show_content = res.data[0].show_content
      // this.textData.id = res.data[0].id
      this.pushform.board_id = String(form.board_id)
      this.currentAdId = form.id
      this.pushform.title = form.title
      this.pushform.sort = form.sort
      this.pushform.show_type = String(form.show_type)
      this.pushform.show_content = form.show_content
      this.pushform.max_show_number = String(form.max_show_number)
      this.pushform.ad_start_time = this.formatTime(
        form.ad_start_time,
        'Y-M-D h:m:s'
      )
      this.pushform.ad_end_time = this.formatTime(
        form.ad_end_time,
        'Y-M-D h:m:s'
      )
      this.pushform.equipment = form.equipment.toString()
      var str = form.url_param
      if (str.indexOf('?id') != -1) {
        this.pushform.url_param = '2'
        var pushStr = str.substring(str.indexOf('?id'))
        this.shop_id = pushStr.substring(4)
        this.cate_id = ''
        this.link = ''
      } else if (str.indexOf('?cateId') != -1) {
        this.pushform.url_param = '1'
        var cateStr = str.substring(str.indexOf('?cateId'))
        this.cate_id = Number(cateStr.substring(8))
        this.shop_id = ''
        this.link = ''
      }
      if (form.url_type === 1) {
        this.pushform.url_param = '3'
        this.link = str
        this.shop_id = ''
        this.cate_id = ''
      }
    },
    //删除
    //确定新增广告位置
    certainAddAd() {
      if (this.allowMultiClick) {
        return
      }

      if (this.pushform.board_id == 2) {
        this.pushform.shop_type == 1
      }
      if (!this.pushform.title) {
        this.$message.error('请填写标题内容')
        return
      }
      if (!this.pushform.show_type) {
        this.$message.error('请选择弹窗类型')
        return
      }

      if (!this.pushform.url_param) {
        this.$message.error('请选择跳转类型填写跳转链接')
        return
      }

      if (this.pushform.url_param == 1) {
        if (!this.cate_id) {
          this.$message.error('请选择商品分类')
          return
        }
      } else if (this.pushform.url_param == 2) {
        if (!this.shop_id) {
          this.$message.error('请填写商品id')
          return
        }
      }

      if (this.pushform.board_id == 1) {
        if (!this.pushform.sort) {
          this.$message.error('请填写排序')
          return
        }
      } else {
        if (!this.pushform.max_show_number) {
          this.$message.error('请选择最高展示次数')
          return
        }
      }

      this.allowMultiClick = true
      if (this.isEditAd) {
        this.updateBannerData()
      } else {
        this.addPushWindowData()
      }
    },
    // 取消
    cancenAddAd() {
      this.showAddEditAD = false
      this.pushform = {
        board_id: '',
        show_type: '',
        title: '',
        show_content: '',
        url_param: '',
        max_show_number: '',
        ad_start_time: '',
        ad_end_time: '',
      }
    },
    // 添加
    async addPushWindowData() {
      var form = {}
      form.title = this.pushform.title
      form.show_type = this.pushform.show_type
      form.board_id = this.pushform.board_id
      form.show_content = this.pushform.show_content
      form.max_show_number = this.pushform.max_show_number
      form.sort = this.pushform.sort

      var startdate = new Date(this.pushform.ad_start_time)
      var enddate = new Date(this.pushform.ad_end_time)
      form.ad_start_time = startdate.getTime() / 1000
      form.ad_end_time = enddate.getTime() / 1000
      form.equipment = this.pushform.equipment

      let url_param = this.pushform.url_param * 1

      switch (url_param) {
        case 1:
          form.url_param =
            '/goods/pages/self/typeList/index?cateId=' + this.cate_id
          form.url_type = 0
          break
        case 2:
          form.url_param =
            '/goods/pages/self/goodsDetail/index?id=' + this.shop_id
          form.url_type = 0
          break
        case 3:
          form.url_param = this.link
          form.url_type = 1
          break
        case 4:
          form.url_param = ''
          form.url_type = 100
          break
      }

      let res = await createBanner(form)
      if (res.code === 10000) {
        this.$message.success(res.message)
        getNewBannerList().then((res) => {
          this.tableData = res.data
        })
        this.allowMultiClick = false
        this.cancenAddAd()
      } else {
        this.allowMultiClick = false
        this.$message.error(res.message)
      }
    },
    // 编辑
    async updateBannerData() {
      var form = {}
      form.id = this.currentAdId
      form.show_type = this.pushform.show_type
      form.title = this.pushform.title
      form.show_content = this.pushform.show_content
      form.max_show_number = this.pushform.max_show_number
      form.board_id = this.pushform.board_id
      form.sort = this.pushform.sort
      var startdate = new Date(this.pushform.ad_start_time)
      var enddate = new Date(this.pushform.ad_end_time)
      form.ad_start_time = startdate.getTime() / 1000
      form.ad_end_time = enddate.getTime() / 1000
      form.equipment = this.pushform.equipment
      let url_param = this.pushform.url_param * 1
      switch (url_param) {
        case 1:
          form.url_param =
            '/goods/pages/self/typeList/index?cateId=' + this.cate_id
          form.url_type = 0
          break
        case 2:
          form.url_param =
            '/goods/pages/self/goodsDetail/index?id=' + this.shop_id
          form.url_type = 0
          break
        case 3:
          form.url_param = this.link
          form.url_type = 1
          break
        case 4:
          form.url_param = ''
          form.url_type = 100
          break
      }
      let res = await updateBanner(form)
      if (res.code == 10000) {
        this.allowMultiClick = false
        this.$message.success(res.message)
        getNewBannerList().then((res) => {
          this.tableData = res.data
        })
        this.showAddEditAD = false
      } else {
        this.allowMultiClick = false
        this.$message.error(res.message)
      }
    },
    //删除弹窗
    deleteAd(form) {
      this.$confirm('确认删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
        .then(() => {
          this.deleteBannerData(form.id)
        })
        .catch(() => {
          console.log('cancel')
        })
    },
    formatNumber(n) {
      n = n.toString()
      return n[1] ? n : '0' + n
    },
    formatTime(number, format) {
      var formateArr = ['Y', 'M', 'D', 'h', 'm', 's']
      var returnArr = []

      var date = new Date(number * 1000)
      returnArr.push(this.formatNumber(date.getFullYear()))
      returnArr.push(this.formatNumber(date.getMonth() + 1))
      returnArr.push(this.formatNumber(date.getDate()))

      returnArr.push(this.formatNumber(date.getHours()))
      returnArr.push(this.formatNumber(date.getMinutes()))
      returnArr.push(this.formatNumber(date.getSeconds()))

      for (var i in returnArr) {
        format = format.replace(formateArr[i], returnArr[i])
      }
      return format
    },

    //deleteBanner
    async deleteBannerData(id) {
      let res = await deleteBanner({ id: id })
      if (res.code === 10000) {
        this.$message.success(res.message)
        getNewBannerList().then((res) => {
          this.tableData = res.data
        })
      } else {
        this.$message.error(res.message)
      }
    },
    //商品分类列表
    async getsupplyproductCateListData() {
      var url = 'id=' + '&cate_name=' + '&page=1' + '&is_enable='
      let res = await supplyproductCateListNew(url)
      if (res.code === 10000) {
        this.cateList = res.data
      } else {
        this.$message.error(res.message)
      }
    },
    //判断时间
    editBeginOrEnd(startTime, endTime) {
      var currentDate = new Date()

      var timestamp = Date.parse(currentDate) / 1000

      if (timestamp >= startTime && timestamp < endTime) {
        return '进行中'
      }

      if (timestamp < startTime) {
        return '未开始'
      }

      if (timestamp >= endTime) {
        return '已结束'
      }
    },
    getFile(file) {
      this.pushform[file.name] = file.files.length > 0 ? file.files[0].url : ''
    },
    tc() {
      return 'text-align:center; color:#333333; font-size:12px;'
    },
    tccolor() {
      return 'text-align:center;background-color:#f5f5f5; font-size:14px;'
    },
  },
}
</script>
<style lang="scss" scoped>
.shop {
  padding: 20px;
}

.img_show {
  height: 200px;
}
</style>
